import { initSentry } from './lib/sentry'

// Initialize Sentry before React renders so it captures all errors
initSentry()

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
